import { withErrorHandling } from "@entrilia/shared/api/axiosHelper";
import adminApi from "../../../../api/adminApi";
import type { AssistantTask } from "../../../../api/types/assistantTypes";
import AssistantNameEditor from "../AssistantNameEditor";
import { createAssistantNameValidator } from "../assistantNames";
import TaskStatusChip from "./TaskStatusChip";

interface Props {
  task: AssistantTask;
  onRenamed: () => Promise<void>;
}

const taskNameValidator = createAssistantNameValidator("Task names");

const renameAssistantTask = withErrorHandling(adminApi.renameAssistantTask);

const TaskTitle = ({ task, onRenamed }: Props) => {
  const handleRename = async (name: string) => {
    const [, error] = await renameAssistantTask(task.taskId, { name });
    return error;
  };

  return (
    <AssistantNameEditor
      name={task.name}
      validator={taskNameValidator}
      tooltip="Rename task"
      placeholder="Enter task name"
      width="40rem"
      logTag="[TaskTitle] renameAssistantTask"
      onRename={handleRename}
      onRenamed={onRenamed}
    >
      <TaskStatusChip task={task} kind="state" />
    </AssistantNameEditor>
  );
};

export default TaskTitle;
